import NewsletterForm from "../../../components/feature/NewsletterForm";

const channels = [
  { icon: "ri-mail-fill", title: "商务 / 品牌合作", desc: "media@jinriguabao.com", tag: "合作通道" },
  { icon: "ri-quill-pen-line", title: "投稿与线索", desc: "tips@jinriguabao.com", tag: "内容共建" },
  { icon: "ri-message-2-fill", title: "读者反馈", desc: "feedback@jinriguabao.com", tag: "意见与建议" },
];

export default function ContactCta() {
  return (
    <section id="contact" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {/* 订阅 CTA */}
          <div id="subscribe" className="scroll-mt-28 flex flex-col justify-between rounded-2xl bg-foreground-950 p-7 md:p-10">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                免费 · 可随时退订
              </span>
              <h2 className="mt-4 font-serif text-2xl font-black leading-tight text-background-50 md:text-3xl">
                订阅今日瓜报，<br />第一时间看懂每一颗瓜
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-background-100/80">
                每日推送头条解读与重点瓜分析摘要，重大专题与封面故事上线即达。不刷屏，只送值得看的内容。
              </p>
            </div>
            <div className="mt-7">
              <NewsletterForm compact />
            </div>
            <div className="mt-5 flex items-center gap-4 text-xs text-background-100/70">
              <span className="flex items-center gap-1"><i className="ri-checkbox-circle-line text-accent-300" aria-hidden="true"></i>零广告打扰</span>
              <span className="flex items-center gap-1"><i className="ri-checkbox-circle-line text-accent-300" aria-hidden="true"></i>原创深度优先</span>
              <span className="flex items-center gap-1"><i className="ri-checkbox-circle-line text-accent-300" aria-hidden="true"></i>随点随退</span>
            </div>
          </div>

          {/* 联系通道 */}
          <div className="flex flex-col">
            <p className="section-kicker text-xs font-semibold text-primary-700">联系我们</p>
            <h2 className="mt-2 font-serif text-2xl font-black text-foreground-950 md:text-3xl">编辑部联系方式</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              无论你是读者、投稿作者、线索提供者还是品牌合作方，都欢迎与我们取得联系，工作日 24 小时内回复。
            </p>
            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {channels.map((c) => (
                <a
                  key={c.tag}
                  href={`mailto:${c.desc}`}
                  className="group rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${c.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 font-serif text-base font-bold text-foreground-950">{c.title}</h3>
                  <p className="mt-1 text-xs text-secondary-700">{c.tag}</p>
                  <p className="mt-2 text-sm text-foreground-600 group-hover:text-primary-700 transition-colors">{c.desc}</p>
                </a>
              ))}
            </div>
            <div className="mt-auto pt-6">
              <div className="flex items-center justify-between rounded-xl bg-accent-50 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-background-50">
                    <i className="ri-clockwise-2-fill text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="font-serif text-base font-bold text-accent-900">响应承诺</p>
                    <p className="text-xs text-accent-700">工作日 24 小时内回复 · 线索信息严格保密</p>
                  </div>
                </div>
                <i className="ri-shield-check-line text-3xl text-accent-600" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}